import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=02bc8a09"
import script from "./announcement.vue?vue&type=script&lang=js"
export * from "./announcement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports